import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';

const styles = theme => ({
    container: {
        width: '95%'
    },
    root: {
      width: '95%',
      minHeight: '500px',
      //marginTop: theme.spacing.unit * 3,
      overflowX: 'auto',
      margin: '0 Auto',
      //display: 'flex',
      //justifyContent: 'center',
    },
    table: {
      tableLayout: 'auto',
      minWidth: 300,
    },
    header:{
        backgroundColor: 'primary',
    },
    leftCell: {
        borderRight: '0.1em solid rgba(224, 224, 224, 1)',
    },
});

const OnlineArbitrationClause = (props) => {

    const { classes } = props;
    console.log('OnlineArbitrationClause windowWidth: '+props.windowWidth)
    return (
        <div className={classes.root}>
           <p style={{ 
              fontWeight: 'bold', color: '#99192D', 
              marginTop:'10px', 
              // margin: '80px', 
              justifyContent:'center',
              fontSize:'20px',
              width:'100%',
              paddingLeft: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              paddingRight: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              textAlign:'center' }}>
             {props.title}
           </p>
           <p style={{ 
              fontWeight: '600', 
              color: 'black', 
              marginTop:'20px', 
              // margin: '80px', 
              fontSize:'20px',
              paddingLeft: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              paddingRight: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              textAlign:'justify' }}>
             {props.mainText}
           </p>
           <p style={{ 
              fontWeight: 'bold', color: '#99192D', 
              marginTop:'20px', 
              // margin: '80px', 
              fontSize:'20px',
              paddingLeft: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              paddingRight: props.windowWidth == undefined? '70px': props.windowWidth > 1200?'250px': props.windowWidth<=1100?'':'250px', 
              textAlign:'justify' }}>
             {props.text}
           </p>
           <p style={{width: '100%', textAlign: 'center'}}>
             <Button style={{
               background: "rgba(255, 255, 255, 0.5)",
               outline: "0",
               color: "#99192D",
               wordWrap: "break-word",
               wordBreak: "break-word",
               border: "2px solid #99192D",
               marginTop: "20px",
               marginBottom: "15px",
               borderRadius: "25px",
               marginLeft: "3px",
               marginRight: "3px",
               boxSizing: "border-box",
               fontSize: "16px",
               "&:hover": {
                 color: "white",
               }
              }} 
              onClick={() => { 
                navigator.clipboard.writeText(props.text); 
              }}>
              {props.copy}
              </Button>
            </p>
        </div>
    );
}

export default withStyles(styles)(OnlineArbitrationClause);